export const globalStateKey = 'global';
